import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { bpSpanPx } from '@jbrowse/core/util';
import { observer } from 'mobx-react';
function OverlayRect(_ref) {
  var rect = _ref.rect,
    region = _ref.region,
    bpPerPx = _ref.bpPerPx,
    rectProps = _objectWithoutProperties(_ref, ["rect", "region", "bpPerPx"]);
  if (!rect) {
    return null;
  }
  var _rect = _slicedToArray(rect, 4),
    leftBp = _rect[0],
    topPx = _rect[1],
    rightBp = _rect[2],
    bottomPx = _rect[3];
  var _bpSpanPx = bpSpanPx(leftBp, rightBp, region, bpPerPx),
    _bpSpanPx2 = _slicedToArray(_bpSpanPx, 2),
    leftPx = _bpSpanPx2[0],
    rightPx = _bpSpanPx2[1];
  var rectTop = Math.round(topPx);
  var screenWidth = (region.end - region.start) / bpPerPx;
  var rectHeight = Math.round(bottomPx - topPx);
  var width = rightPx - leftPx;
  if (leftPx + width < 0) {
    return null;
  }
  var leftWithinBlock = Math.max(leftPx, 0);
  var diff = leftWithinBlock - leftPx;
  var widthWithinBlock = Math.max(1, Math.min(width - diff, screenWidth));
  return React.createElement("rect", _objectSpread({
    x: leftWithinBlock - 2,
    y: rectTop - 2,
    width: widthWithinBlock + 4,
    height: rectHeight + 4
  }, rectProps));
}
function SvgOverlay(_ref2) {
  var _ref2$displayModel = _ref2.displayModel,
    displayModel = _ref2$displayModel === void 0 ? {} : _ref2$displayModel,
    blockKey = _ref2.blockKey,
    region = _ref2.region,
    bpPerPx = _ref2.bpPerPx,
    movedDuringLastMouseDown = _ref2.movedDuringLastMouseDown,
    handlers = _objectWithoutProperties(_ref2, ["displayModel", "blockKey", "region", "bpPerPx", "movedDuringLastMouseDown"]);
  var _a, _b;
  var selectedFeatureId = displayModel.selectedFeatureId,
    featureIdUnderMouse = displayModel.featureIdUnderMouse,
    contextMenuFeature = displayModel.contextMenuFeature;
  var mouseoverFeatureId = featureIdUnderMouse || (contextMenuFeature === null || contextMenuFeature === void 0 ? void 0 : contextMenuFeature.id());
  function onFeatureMouseDown(event) {
    var handler = handlers.onFeatureMouseDown;
    if (!(handler && mouseoverFeatureId)) {
      return undefined;
    }
    return handler(event, mouseoverFeatureId);
  }
  function onFeatureMouseEnter(event) {
    var handler = handlers.onFeatureMouseEnter;
    if (!(handler && mouseoverFeatureId)) {
      return undefined;
    }
    return handler(event, mouseoverFeatureId);
  }
  function onFeatureMouseOut(event) {
    var handler = handlers.onFeatureMouseOut;
    if (!(handler && mouseoverFeatureId)) {
      return undefined;
    }
    return handler(event, mouseoverFeatureId);
  }
  function onFeatureMouseOver(event) {
    var handler = handlers.onFeatureMouseOver;
    if (!(handler && mouseoverFeatureId)) {
      return undefined;
    }
    return handler(event, mouseoverFeatureId);
  }
  function onFeatureMouseUp(event) {
    var handler = handlers.onFeatureMouseUp;
    if (!(handler && mouseoverFeatureId)) {
      return undefined;
    }
    return handler(event, mouseoverFeatureId);
  }
  function onFeatureMouseLeave(event) {
    var handler = handlers.onFeatureMouseLeave;
    if (!(handler && mouseoverFeatureId)) {
      return undefined;
    }
    return handler(event, mouseoverFeatureId);
  }
  function onFeatureMouseMove(event) {
    var handler = handlers.onFeatureMouseMove;
    if (!(handler && mouseoverFeatureId)) {
      return undefined;
    }
    return handler(event, mouseoverFeatureId);
  }
  function onFeatureClick(event) {
    if (movedDuringLastMouseDown) {
      return undefined;
    }
    var handler = handlers.onFeatureClick;
    if (!(handler && mouseoverFeatureId)) {
      return undefined;
    }
    event.stopPropagation();
    return handler(event, mouseoverFeatureId);
  }
  function onFeatureContextMenu(event) {
    var handler = handlers.onFeatureContextMenu;
    if (!(handler && mouseoverFeatureId)) {
      return undefined;
    }
    return handler(event, mouseoverFeatureId);
  }
  return React.createElement(React.Fragment, null, mouseoverFeatureId ? React.createElement(OverlayRect, {
    rect: (_a = displayModel.getFeatureByID) === null || _a === void 0 ? void 0 : _a.call(displayModel, blockKey, mouseoverFeatureId),
    region: region,
    bpPerPx: bpPerPx,
    fill: "#000",
    fillOpacity: "0.2",
    onMouseDown: onFeatureMouseDown,
    onMouseEnter: onFeatureMouseEnter,
    onMouseOut: onFeatureMouseOut,
    onMouseOver: onFeatureMouseOver,
    onMouseUp: onFeatureMouseUp,
    onMouseLeave: onFeatureMouseLeave,
    onMouseMove: onFeatureMouseMove,
    onClick: onFeatureClick,
    onContextMenu: onFeatureContextMenu,
    onFocus: onFeatureMouseOver,
    onBlur: onFeatureMouseOut,
    "data-testid": mouseoverFeatureId
  }) : null, selectedFeatureId ? React.createElement(OverlayRect, {
    rect: (_b = displayModel.getFeatureByID) === null || _b === void 0 ? void 0 : _b.call(displayModel, blockKey, selectedFeatureId),
    region: region,
    bpPerPx: bpPerPx,
    stroke: "#00b8ff",
    fill: "none"
  }) : null);
}
export default observer(SvgOverlay);